module.exports = __webpack_public_path__ + "img/yacht-2.256a4cdb.jpg";